(function () {
  function readStoredAttribution(key) {
    try {
      return window.sessionStorage.getItem('senmit_' + key) || '';
    } catch (error) {
      return '';
    }
  }

  function storeAttribution(key, value) {
    if (!value) return;
    try {
      window.sessionStorage.setItem('senmit_' + key, value);
    } catch (error) {
      // The form still works when storage is unavailable.
    }
  }

  var currentParams = new URLSearchParams(window.location.search);
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'].forEach(function (key) {
    storeAttribution(key, currentParams.get(key));
  });

  function initializeQuoteForm(root) {
    var form = root.querySelector('#SenmitWindowDoorQuote');
    var success = root.querySelector('[data-senmit-quote-success]');

    if (success) {
      success.focus();
      if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_source: 'window_door_quote' });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'generate_lead', lead_source: 'window_door_quote' });
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Window and door quote' });
    }

    if (!form) return;

    var params = currentParams;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'].forEach(function (key) {
      var value = params.get(key) || readStoredAttribution(key);
      if (params.get(key)) storeAttribution(key, params.get(key));
      var input = form.querySelector('[data-senmit-utm="' + key + '"]');
      if (input) input.value = value;
    });

    var pageUrl = form.querySelector('[data-senmit-page-url]');
    if (pageUrl) pageUrl.value = window.location.href;

    var productSelection = form.querySelector('[data-senmit-product-selection]');
    if (productSelection) productSelection.value = params.get('product') || '';

    form.addEventListener('submit', function (event) {
      var firstName = form.querySelector('[data-senmit-first-name]');
      var lastName = form.querySelector('[data-senmit-last-name]');
      var fullName = form.querySelector('[data-senmit-full-name]');
      if (fullName) fullName.value = [firstName && firstName.value, lastName && lastName.value].filter(Boolean).join(' ');

      var productGroup = form.querySelector('[data-senmit-product-group]');
      var productError = form.querySelector('[data-senmit-product-error]');
      var selectedProduct = productGroup && productGroup.querySelector('input:checked');
      if (!selectedProduct) {
        event.preventDefault();
        if (productError) productError.hidden = false;
        if (productGroup) {
          productGroup.setAttribute('aria-invalid', 'true');
          productGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else if (productError) {
        productError.hidden = true;
        productGroup.removeAttribute('aria-invalid');
      }
    });
  }

  document.querySelectorAll('[data-senmit-quote-root]').forEach(initializeQuoteForm);
})();
